import React from "react";
import { Link } from "react-router-dom";
// import "./footer.css";

const Footer = () => {
  return (
    <footer className="main-footer">

      <div className="container footer-grid">

        {/* COLUMN 1 — COMPANY */}
        <div className="footer-about">
          <h2 className="footer-logo">APEX Consultants</h2>

          <p>
           Our experts specialize in facilitating Export–Import licenses, DGFT liaisoning, and Industrial Subsidy approvals. With over 12 years of professional experience, we assist businesses across India in navigating government policies, regulatory compliance, and incentive schemes efficiently.
          </p>

          {/* <div className="social-icons">
            <span>f</span>
            <span>t</span>
            <span>in</span>
            <span>ig</span>
          </div> */}
        </div>

        {/* COLUMN 2 — QUICK LINKS */}
        <div>
          <h3 className="footer-title">QUICK LINKS</h3>
          <ol className="footer-links">
            <li><Link to="/about">About Us</Link></li>
            {/* <li><Link to="/notifications">Notifications</Link></li> */}
            <li><Link to="/dgft/iec">DGFT Liaisoning (EXIM)</Link></li>
            <li><Link to="/subsidy/state">Industrial Subsidies</Link></li>
            {/* <li><Link to="/blog">Blog</Link></li> */}
          </ol>
        </div>

        {/* COLUMN 3 — BRANCHES */}
        {/* <div>
          <h3 className="footer-title">BRANCHES</h3>
          <ul className="footer-links">
            <li>Telangana</li>
            <li>Andhra Pradesh</li>
            <li>Maharashtra</li>
            <li>Karnataka</li>
          </ul>
        </div> */}

        {/* COLUMN 4 — CONTACT */}
        <div>
          <h3 className="footer-title">CONTACT US</h3>
          <div className="contact-info">
            <p>📧 info@apexconsultants.in</p>
            <p>☎ +91 72077 57511</p>
            <p>
              H.No 9-133/03, F.No 302,<br/>
              Legend Estates, Bachupally,<br/>
              Hyderabad – 500090
            </p>
            <p>🌐 www.apexconsultants.in</p>
          </div>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <p>
          © {new Date().getFullYear()} APEX Consultants. All Rights Reserved.
        </p>
        <p>Privacy Policy | Terms & Conditions</p>
      </div>
      <div className="footer-developed">
  <p>
    Developed By <strong>SUNIJA Solutions</strong> | ☎ +91 6300479820
  </p>
</div>

      <div className="footer-disclaimer">
        DISCLAIMER: We are Consultants and not Govt. Authority of India or Govt. Agency of India.
      </div>

    </footer>
  );
};

export default Footer;
